import { BusinessExpense } from "@/hooks/useBusinessExpenses";

export const BUSINESS_EXPENSE_TYPES: BusinessExpense["expenses_type"][] = [
  "Reembolso",
  "Nómina",
  "Extras",
  "Otros",
] as const;

export const BUSINESS_PAYMENT_TYPES: BusinessExpense["payment_type"][] = [
  "Efectivo",
  "Transferencia",
  "Tarjeta de Crédito",
  "Tarjeta de Débito",
  "Deducción",
] as const;
